// Export an array of topics for VA 1st Grade Science
const md4thScienceQuizContent = [
  {
    "slug": "photosynthesis",
    "title": "Photosynthesis",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do plants use to start photosynthesis?",
        "questionImage": "",
        "answers": [
          { "text": "Sunlight", "correct": true, "image": "" },
          { "text": "Moonlight", "correct": false, "image": "" },
          { "text": "Fire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do roots collect for photosynthesis?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Sand", "correct": false, "image": "" },
          { "text": "Metal", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What gas do plants take from the air?",
        "questionImage": "",
        "answers": [
          { "text": "Carbon dioxide", "correct": true, "image": "" },
          { "text": "Oxygen", "correct": false, "image": "" },
          { "text": "Helium", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes plants green?",
        "questionImage": "",
        "answers": [
          { "text": "Chlorophyll", "correct": true, "image": "" },
          { "text": "Nitrogen", "correct": false, "image": "" },
          { "text": "Salt", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What gas do plants release?",
        "questionImage": "",
        "answers": [
          { "text": "Oxygen", "correct": true, "image": "" },
          { "text": "Carbon dioxide", "correct": false, "image": "" },
          { "text": "Methane", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "ecoenergyflow",
    "title": "Eco Energy Flow",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Where does energy in most food chains start?",
        "questionImage": "",
        "answers": [
          { "text": "Sun", "correct": true, "image": "" },
          { "text": "Moon", "correct": false, "image": "" },
          { "text": "Stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Who makes food using sunlight?",
        "questionImage": "",
        "answers": [
          { "text": "Plants", "correct": true, "image": "" },
          { "text": "Animals", "correct": false, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens to most energy in a plant?",
        "questionImage": "",
        "answers": [
          { "text": "Used for life", "correct": true, "image": "" },
          { "text": "Saved forever", "correct": false, "image": "" },
          { "text": "Wasted fully", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals at the top of a chain need…",
        "questionImage": "",
        "answers": [
          { "text": "More food", "correct": true, "image": "" },
          { "text": "Less food", "correct": false, "image": "" },
          { "text": "No food", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. At each step, much energy is lost as…",
        "questionImage": "",
        "answers": [
          { "text": "Heat", "correct": true, "image": "" },
          { "text": "Ice", "correct": false, "image": "" },
          { "text": "Gold", "correct": false, "image": "" }
        ]
      }
    ]
  },

  {
  "slug": "animallifecycle",
  "title": "Animal Life Cycle",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each stage to the life cycle idea.",
      "options": [
        { "id": "born", "text": "Born", "image": "", "targetText": "Start", "targetImage": "" },
        { "id": "developing", "text": "Developing", "image": "", "targetText": "Grow", "targetImage": "" },
        { "id": "reproducing", "text": "Reproducing", "image": "", "targetText": "New life", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match human stages to their descriptions.",
      "options": [
        { "id": "baby", "text": "Baby", "image": "", "targetText": "0–3 years", "targetImage": "" },
        { "id": "teen", "text": "Teen", "image": "", "targetText": "13–18 years", "targetImage": "" },
        { "id": "adult", "text": "Adult", "image": "", "targetText": "Grown", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each phase to the idea.",
      "options": [
        { "id": "egg", "text": "Egg", "image": "", "targetText": "Beginning", "targetImage": "" },
        { "id": "child", "text": "Child", "image": "", "targetText": "Learning", "targetImage": "" },
        { "id": "old", "text": "Old age", "image": "", "targetText": "Cycle ends", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match stage to the word.",
      "options": [
        { "id": "teen2", "text": "Teen", "image": "", "targetText": "Adolescent", "targetImage": "" },
        { "id": "adult2", "text": "Adult", "image": "", "targetText": "Independent", "targetImage": "" },
        { "id": "baby2", "text": "Baby", "image": "", "targetText": "Learns", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the role to the stage.",
      "options": [
        { "id": "adult3", "text": "Adult", "image": "", "targetText": "Family", "targetImage": "" },
        { "id": "old3", "text": "Old", "image": "", "targetText": "Gray hair", "targetImage": "" },
        { "id": "reproduce", "text": "Reproduce", "image": "", "targetText": "Cycle restarts", "targetImage": "" }
      ]
    }
  ]
},

{
  "slug": "plantlifecycle",
  "title": "Plant Life Cycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What protects the seed?",
      "questionImage": "",
      "answers": [
        { "text": "Seed coat", "correct": true, "image": "" },
        { "text": "Petal", "correct": false, "image": "" },
        { "text": "Stem", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What grows down first?",
      "questionImage": "",
      "answers": [
        { "text": "Root", "correct": true, "image": "" },
        { "text": "Leaf", "correct": false, "image": "" },
        { "text": "Flower", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What grows up above the ground?",
      "questionImage": "",
      "answers": [
        { "text": "Shoot", "correct": true, "image": "" },
        { "text": "Fruit", "correct": false, "image": "" },
        { "text": "Seed coat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is a seedling?",
      "questionImage": "",
      "answers": [
        { "text": "Small plant", "correct": true, "image": "" },
        { "text": "Root", "correct": false, "image": "" },
        { "text": "Flower", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helps plants reproduce?",
      "questionImage": "",
      "answers": [
        { "text": "Flowers or spores", "correct": true, "image": "" },
        { "text": "Rocks", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "ecosystemlevels",
  "title": "Ecosystem Levels",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the first level?",
      "questionImage": "",
      "answers": [
        { "text": "Organism", "correct": true, "image": "" },
        { "text": "Community", "correct": false, "image": "" },
        { "text": "Ecosystem", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Many organisms together make a…",
      "questionImage": "",
      "answers": [
        { "text": "Population", "correct": true, "image": "" },
        { "text": "Rock", "correct": false, "image": "" },
        { "text": "Cloud", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Populations together form a…",
      "questionImage": "",
      "answers": [
        { "text": "Community", "correct": true, "image": "" },
        { "text": "Mountain", "correct": false, "image": "" },
        { "text": "River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Add nonliving parts to make an…",
      "questionImage": "",
      "answers": [
        { "text": "Ecosystem", "correct": true, "image": "" },
        { "text": "City", "correct": false, "image": "" },
        { "text": "House", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which level includes all the others here?",
      "questionImage": "",
      "answers": [
        { "text": "Ecosystem", "correct": true, "image": "" },
        { "text": "Population", "correct": false, "image": "" },
        { "text": "Organism", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "foodchain",
  "title": "Food Chain",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who eats grass?",
      "questionImage": "",
      "answers": [
        { "text": "Grasshopper", "correct": true, "image": "" },
        { "text": "Snake", "correct": false, "image": "" },
        { "text": "Hawk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who eats the grasshopper?",
      "questionImage": "",
      "answers": [
        { "text": "Frog", "correct": true, "image": "" },
        { "text": "Hawk", "correct": false, "image": "" },
        { "text": "Tree", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who eats the frog?",
      "questionImage": "",
      "answers": [
        { "text": "Snake", "correct": true, "image": "" },
        { "text": "Grass", "correct": false, "image": "" },
        { "text": "Mouse", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who eats the snake?",
      "questionImage": "",
      "answers": [
        { "text": "Hawk", "correct": true, "image": "" },
        { "text": "Frog", "correct": false, "image": "" },
        { "text": "Rabbit", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does a food chain show?",
      "questionImage": "",
      "answers": [
        { "text": "Energy flow", "correct": true, "image": "" },
        { "text": "Seasons", "correct": false, "image": "" },
        { "text": "Weather", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "foodweb",
  "title": "Food Web",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What shows many feeding paths?",
      "questionImage": "",
      "answers": [
        { "text": "Food web", "correct": true, "image": "" },
        { "text": "Food chain", "correct": false, "image": "" },
        { "text": "Map", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Acorns are food for…",
      "questionImage": "",
      "answers": [
        { "text": "Mice", "correct": true, "image": "" },
        { "text": "Owls", "correct": false, "image": "" },
        { "text": "Snakes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who eats mice?",
      "questionImage": "",
      "answers": [
        { "text": "Owls", "correct": true, "image": "" },
        { "text": "Bugs", "correct": false, "image": "" },
        { "text": "Trees", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. If one animal disappears, the web becomes…",
      "questionImage": "",
      "answers": [
        { "text": "Weaker", "correct": true, "image": "" },
        { "text": "Stronger", "correct": false, "image": "" },
        { "text": "Exactly the same", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who eats rabbits?",
      "questionImage": "",
      "answers": [
        { "text": "Foxes", "correct": true, "image": "" },
        { "text": "Grass", "correct": false, "image": "" },
        { "text": "Skunks", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "determineweather",
  "title": "Determine Weather",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each term to what it tells us about weather.",
      "options": [
        { "id": "temperature", "text": "Temperature", "image": "", "targetText": "Heat level", "targetImage": "" },
        { "id": "precipitation", "text": "Precipitation", "image": "", "targetText": "Rain/snow", "targetImage": "" },
        { "id": "winddir", "text": "Wind direction", "image": "", "targetText": "N/E/S/W", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match more weather terms to their meaning.",
      "options": [
        { "id": "windspeed", "text": "Wind speed", "image": "", "targetText": "How fast", "targetImage": "" },
        { "id": "pressure", "text": "Air pressure", "image": "", "targetText": "Barometer", "targetImage": "" },
        { "id": "humidity", "text": "Humidity", "image": "", "targetText": "Water vapor", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match item to example or unit.",
      "options": [
        { "id": "precip2", "text": "Precipitation", "image": "", "targetText": "Hail/sleet", "targetImage": "" },
        { "id": "winds2", "text": "Wind speed", "image": "", "targetText": "Miles/hour", "targetImage": "" },
        { "id": "temp2", "text": "Temperature", "image": "", "targetText": "Degrees", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match tools to what they measure.",
      "options": [
        { "id": "barom2", "text": "Barometer", "image": "", "targetText": "Pressure", "targetImage": "" },
        { "id": "lookdir", "text": "Wind vane", "image": "", "targetText": "Direction", "targetImage": "" },
        { "id": "gauge", "text": "Rain gauge", "image": "", "targetText": "Amount", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the question we ask to the weather part.",
      "options": [
        { "id": "q1", "text": "How warm?", "image": "", "targetText": "Temperature", "targetImage": "" },
        { "id": "q2", "text": "How windy?", "image": "", "targetText": "Wind speed", "targetImage": "" },
        { "id": "q3", "text": "How wet?", "image": "", "targetText": "Humidity", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "earthsrotation",
  "title": "Earth’s Rotation",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Earth spins on its what?",
      "questionImage": "",
      "answers": [
        { "text": "Axis", "correct": true, "image": "" },
        { "text": "Rail", "correct": false, "image": "" },
        { "text": "Rope", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How long is one full turn of Earth?",
      "questionImage": "",
      "answers": [
        { "text": "24 hours", "correct": true, "image": "" },
        { "text": "24 days", "correct": false, "image": "" },
        { "text": "12 hours", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What makes day and night?",
      "questionImage": "",
      "answers": [
        { "text": "Rotation", "correct": true, "image": "" },
        { "text": "Revolution", "correct": false, "image": "" },
        { "text": "Eclipse", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do stars seem to move across the sky?",
      "questionImage": "",
      "answers": [
        { "text": "Earth turns", "correct": true, "image": "" },
        { "text": "Stars walk", "correct": false, "image": "" },
        { "text": "Sky spins", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun seems to rise in the…",
      "questionImage": "",
      "answers": [
        { "text": "East", "correct": true, "image": "" },
        { "text": "West", "correct": false, "image": "" },
        { "text": "North", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "suntopluto",
  "title": "Sun to Pluto",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 1).",
      "options": [
        { "id": "mercury", "text": "Mercury", "image": "", "targetText": "Closest to Sun", "targetImage": "" },
        { "id": "venus", "text": "Venus", "image": "", "targetText": "Thick clouds", "targetImage": "" },
        { "id": "earth", "text": "Earth", "image": "", "targetText": "One moon", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 2).",
      "options": [
        { "id": "mars", "text": "Mars", "image": "", "targetText": "Red planet", "targetImage": "" },
        { "id": "jupiter", "text": "Jupiter", "image": "", "targetText": "Biggest planet", "targetImage": "" },
        { "id": "saturn", "text": "Saturn", "image": "", "targetText": "Rings", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 3).",
      "options": [
        { "id": "uranus", "text": "Uranus", "image": "", "targetText": "Tilts on side", "targetImage": "" },
        { "id": "neptune", "text": "Neptune", "image": "", "targetText": "Strong winds", "targetImage": "" },
        { "id": "pluto", "text": "Pluto", "image": "", "targetText": "Dwarf planet", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match object to role or place.",
      "options": [
        { "id": "sun", "text": "Sun", "image": "", "targetText": "Gives energy", "targetImage": "" },
        { "id": "mercury2", "text": "Mercury", "image": "", "targetText": "Smallest planet", "targetImage": "" },
        { "id": "venus2", "text": "Venus", "image": "", "targetText": "2nd from Sun", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match more facts.",
      "options": [
        { "id": "earth2", "text": "Earth", "image": "", "targetText": "Water & land", "targetImage": "" },
        { "id": "jupiter2", "text": "Jupiter", "image": "", "targetText": "Red Spot storm", "targetImage": "" },
        { "id": "mars2", "text": "Mars", "image": "", "targetText": "4th planet", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "earthsrevolution",
  "title": "Earth’s Revolution",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. One revolution takes how long?",
      "questionImage": "",
      "answers": [
        { "text": "1 year", "correct": true, "image": "" },
        { "text": "1 week", "correct": false, "image": "" },
        { "text": "1 hour", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many days is that?",
      "questionImage": "",
      "answers": [
        { "text": "365", "correct": true, "image": "" },
        { "text": "24", "correct": false, "image": "" },
        { "text": "30", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Earth goes around the…",
      "questionImage": "",
      "answers": [
        { "text": "Sun", "correct": true, "image": "" },
        { "text": "Moon", "correct": false, "image": "" },
        { "text": "Pole", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Another word for Earth’s path is…",
      "questionImage": "",
      "answers": [
        { "text": "Orbit", "correct": true, "image": "" },
        { "text": "Tunnel", "correct": false, "image": "" },
        { "text": "Bridge", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Revolution means one…",
      "questionImage": "",
      "answers": [
        { "text": "Trip", "correct": true, "image": "" },
        { "text": "Spin", "correct": false, "image": "" },
        { "text": "Jump", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "moonphasesrap",
  "title": "Moon Phases Rap",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which phase is dark?",
      "questionImage": "",
      "answers": [
        { "text": "New moon", "correct": true, "image": "" },
        { "text": "Full moon", "correct": false, "image": "" },
        { "text": "Gibbous", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Less than half lit is…",
      "questionImage": "",
      "answers": [
        { "text": "Crescent", "correct": true, "image": "" },
        { "text": "Full", "correct": false, "image": "" },
        { "text": "Eclipse", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A half-moon is called a…",
      "questionImage": "",
      "answers": [
        { "text": "Quarter moon", "correct": true, "image": "" },
        { "text": "New moon", "correct": false, "image": "" },
        { "text": "Blue moon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. More than half lit is…",
      "questionImage": "",
      "answers": [
        { "text": "Gibbous", "correct": true, "image": "" },
        { "text": "Crescent", "correct": false, "image": "" },
        { "text": "Shadow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which phase is brightest?",
      "questionImage": "",
      "answers": [
        { "text": "Full moon", "correct": true, "image": "" },
        { "text": "Waning crescent", "correct": false, "image": "" },
        { "text": "New moon", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "moonphasesrock",
  "title": "Moon Phases Rock",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each phase to dark or lit.",
      "options": [
        { "id": "new", "text": "New moon", "image": "", "targetText": "Dark", "targetImage": "" },
        { "id": "crescent", "text": "Crescent", "image": "", "targetText": "Less than half lit", "targetImage": "" },
        { "id": "quarter", "text": "Quarter moon", "image": "", "targetText": "Half lit", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase to when we see it.",
      "options": [
        { "id": "new2", "text": "New moon", "image": "", "targetText": "Between Sun & Earth", "targetImage": "" },
        { "id": "gibbous", "text": "Gibbous", "image": "", "targetText": "More than half lit", "targetImage": "" },
        { "id": "full", "text": "Full moon", "image": "", "targetText": "Face all lit", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase to sequence word.",
      "options": [
        { "id": "waxcres", "text": "Waxing crescent", "image": "", "targetText": "Getting bigger", "targetImage": "" },
        { "id": "firstq", "text": "First quarter", "image": "", "targetText": "Halfway lit", "targetImage": "" },
        { "id": "waxgib", "text": "Waxing gibbous", "image": "", "targetText": "Almost full", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match waning phases to ideas.",
      "options": [
        { "id": "wanegib", "text": "Waning gibbous", "image": "", "targetText": "Past full", "targetImage": "" },
        { "id": "lastq", "text": "Last quarter", "image": "", "targetText": "Half lit", "targetImage": "" },
        { "id": "wanecre", "text": "Waning crescent", "image": "", "targetText": "Thin sliver", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase names to category.",
      "options": [
        { "id": "waxing", "text": "Waxing", "image": "", "targetText": "Growing", "targetImage": "" },
        { "id": "waning", "text": "Waning", "image": "", "targetText": "Shrinking", "targetImage": "" },
        { "id": "full2", "text": "Full moon", "image": "", "targetText": "All lit", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "tides",
  "title": "Tides",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What mainly causes ocean tides on Earth?",
      "questionImage": "",
      "answers": [
        { "text": "Gravity", "correct": true, "image": "" },
        { "text": "Wind", "correct": false, "image": "" },
        { "text": "Light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. One high tide is on the side facing the…",
      "questionImage": "",
      "answers": [
        { "text": "Moon", "correct": true, "image": "" },
        { "text": "Poles", "correct": false, "image": "" },
        { "text": "Mountains", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The other high tide is on the…",
      "questionImage": "",
      "answers": [
        { "text": "Opposite side", "correct": true, "image": "" },
        { "text": "Equator only", "correct": false, "image": "" },
        { "text": "No-ocean side", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do oceans change level more than land?",
      "questionImage": "",
      "answers": [
        { "text": "Water flows", "correct": true, "image": "" },
        { "text": "Land is heavier", "correct": false, "image": "" },
        { "text": "Sun is hotter", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Low tides happen where the pulls are…",
      "questionImage": "",
      "answers": [
        { "text": "Weaker/balanced", "correct": true, "image": "" },
        { "text": "Exploding", "correct": false, "image": "" },
        { "text": "Frozen", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "themoon",
  "title": "The Moon",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Bright, bumpy areas on the Moon are called…",
      "questionImage": "",
      "answers": [
        { "text": "Highlands", "correct": true, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Dark spots called mare were filled with…",
      "questionImage": "",
      "answers": [
        { "text": "Lava", "correct": true, "image": "" },
        { "text": "Water", "correct": false, "image": "" },
        { "text": "Ice", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Moon has almost no…",
      "questionImage": "",
      "answers": [
        { "text": "Atmosphere", "correct": true, "image": "" },
        { "text": "Rocks", "correct": false, "image": "" },
        { "text": "Craters", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who first walked on the Moon?",
      "questionImage": "",
      "answers": [
        { "text": "Armstrong", "correct": true, "image": "" },
        { "text": "Glenn", "correct": false, "image": "" },
        { "text": "Gagarin", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which mission landed in 1969?",
      "questionImage": "",
      "answers": [
        { "text": "Apollo 11", "correct": true, "image": "" },
        { "text": "Apollo 1", "correct": false, "image": "" },
        { "text": "Apollo 13", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "thesun",
  "title": "The Sun",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. About how many Earths could fit inside the Sun?",
      "questionImage": "",
      "answers": [
        { "text": "About 1 million", "correct": true, "image": "" },
        { "text": "About 1,000", "correct": false, "image": "" },
        { "text": "About 100", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun is mostly which two elements?",
      "questionImage": "",
      "answers": [
        { "text": "Hydrogen & helium", "correct": true, "image": "" },
        { "text": "Iron & lead", "correct": false, "image": "" },
        { "text": "Sodium & chlorine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun’s energy comes from hydrogen changing to…",
      "questionImage": "",
      "answers": [
        { "text": "Helium", "correct": true, "image": "" },
        { "text": "Oxygen", "correct": false, "image": "" },
        { "text": "Carbon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Sunspots are seen on the…",
      "questionImage": "",
      "answers": [
        { "text": "Photosphere", "correct": true, "image": "" },
        { "text": "Corona", "correct": false, "image": "" },
        { "text": "Mantle", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun’s outermost layer is the…",
      "questionImage": "",
      "answers": [
        { "text": "Corona", "correct": true, "image": "" },
        { "text": "Core", "correct": false, "image": "" },
        { "text": "Chromosphere", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "theearth",
  "title": "The Earth",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. One full spin (rotation) of Earth takes…",
      "questionImage": "",
      "answers": [
        { "text": "24 hours", "correct": true, "image": "" },
        { "text": "24 days", "correct": false, "image": "" },
        { "text": "1 year", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Seasons happen mainly because of Earth’s…",
      "questionImage": "",
      "answers": [
        { "text": "Tilt", "correct": true, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" },
        { "text": "Wind", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Earth’s shape is…",
      "questionImage": "",
      "answers": [
        { "text": "Spherical", "correct": true, "image": "" },
        { "text": "Flat", "correct": false, "image": "" },
        { "text": "Square", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The main gas in our air is…",
      "questionImage": "",
      "answers": [
        { "text": "Nitrogen", "correct": true, "image": "" },
        { "text": "Oxygen", "correct": false, "image": "" },
        { "text": "Carbon dioxide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Two forces that affect Earth are…",
      "questionImage": "",
      "answers": [
        { "text": "Gravity & magnetism", "correct": true, "image": "" },
        { "text": "Light & sound", "correct": false, "image": "" },
        { "text": "Heat & cold", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "ocean",
  "title": "Ocean",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Seawater is mixed with dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Gases", "correct": true, "image": "" },
        { "text": "Wood", "correct": false, "image": "" },
        { "text": "Glass", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Seawater also contains dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Solids (salts)", "correct": true, "image": "" },
        { "text": "Feathers", "correct": false, "image": "" },
        { "text": "Paper", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As you go deeper, ocean temperature usually…",
      "questionImage": "",
      "answers": [
        { "text": "Decreases", "correct": true, "image": "" },
        { "text": "Increases", "correct": false, "image": "" },
        { "text": "Stays the same", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As you go deeper, water pressure…",
      "questionImage": "",
      "answers": [
        { "text": "Increases", "correct": true, "image": "" },
        { "text": "Disappears", "correct": false, "image": "" },
        { "text": "Drops to zero", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The ocean is a mix of water and dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Gases & solids", "correct": true, "image": "" },
        { "text": "Smoke", "correct": false, "image": "" },
        { "text": "Plastic", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "watershed",
  "title": "Watershed",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. A watershed is land that drains to a…",
      "questionImage": "",
      "answers": [
        { "text": "Water body", "correct": true, "image": "" },
        { "text": "Mountain", "correct": false, "image": "" },
        { "text": "Cave", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Much of Virginia’s water drains to the…",
      "questionImage": "",
      "answers": [
        { "text": "Chesapeake Bay", "correct": true, "image": "" },
        { "text": "Great Lakes", "correct": false, "image": "" },
        { "text": "Pacific Ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Virginia water also drains to the…",
      "questionImage": "",
      "answers": [
        { "text": "Atlantic Ocean", "correct": true, "image": "" },
        { "text": "Arctic Ocean", "correct": false, "image": "" },
        { "text": "Indian Ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Some Virginia water reaches the Mississippi River and then the…",
      "questionImage": "",
      "answers": [
        { "text": "Gulf of Mexico", "correct": true, "image": "" },
        { "text": "Chesapeake Bay", "correct": false, "image": "" },
        { "text": "Canal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Another Virginia drainage area is the…",
      "questionImage": "",
      "answers": [
        { "text": "Albemarle Sound", "correct": true, "image": "" },
        { "text": "Hudson Bay", "correct": false, "image": "" },
        { "text": "Mediterranean Sea", "correct": false, "image": "" }
      ]
    }
  ]
},













  





]

export default md4thScienceQuizContent;
